import Vue from "vue";
import Router from 'vue-router';
Vue.use(Router);

const routes = [
  {
    path: "/login",
    name: "Login",
    meta: {
      onlyWhenLoggedOut: true,
      title: 'Login',
    },
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login.vue")
  },
  {
    path: '/',
    component: () => import('../components/layouts/Default.vue'),
    name: "Default",
    children: [
      {
        path: "/news",
        name: "News",
        meta: {
          title: 'Les actualités',
        },
        component: () => import(/* webpackChunkName: "News" */ "../views/News/News.vue")
      },
      {
        path: "/news/ajouter-nouveau-article",
        name: "NewsCreate",
        meta: {
          title: 'Ajouter un article'
        },
        component: () =>
            import(/* webpackChunkName: "News" */ "../views/News/Form.vue")
      },
      {
        path: "/news/edit",
        name: "NewsEdit",
        meta: {
          title: 'News Edit',
        },
        component: () =>
            import(/* webpackChunkName: "News" */ "../views/News/Form.vue")
      },
      {
        path: "/salon",
        name: "Salon",
        meta: {
          title: 'Salon',
        },
        component: () => import(/* webpackChunkName: "Salon" */ "../views/Salon/Salon.vue")
      },
      {
        path: "/salon/create",
        name: "SalonCreate",
        meta: {
          title: 'Salon Create',
        },
        component: () =>
            import(/* webpackChunkName: "Salon" */ "../views/Salon/Form.vue")
      },
      {
        path: "/news/edit",
        name: "SalonEdit",
        meta: {
          title: 'Salon Edit',
        },
        component: () =>
            import(/* webpackChunkName: "Salon" */ "../views/Salon/Form.vue")
      },
      {
        path: "/conseil-candidature",
        name: "IndexResume",
        meta: {
          title: 'Dossiers de Candidature',
        },
        component: () => import(/* webpackChunkName: "IndexResume" */ "../views/Resume/Index.vue")
      },
      {
        path: "/conseil-candidature/create",
        name: "ResumeCreate",
        meta: {
          title: 'Ajouter un exemple de dossier de candidature',
        },
        component: () =>
            import(/* webpackChunkName: "ResumeCreate" */ "../views/Resume/IndexForm.vue")
      },
      {
        path: "/conseil-candidature/edit",
        name: "ResumeEdit",
        meta: {
          title: 'Resume Edit',
        },
        component: () =>
            import(/* webpackChunkName: "ResumeEdit" */ "../views/Resume/IndexForm.vue")
      },
      {
        path: "/etudiants",
        name: "User",
        meta: {
          title: 'Étudiants',
        },
        component: () => import(/* webpackChunkName: "User" */ "../views/User/User.vue")
      },
      {
        path: "/lumiere-specialite",
        name: "Speciality",
        meta: {
          title: 'Spécialités',
        },
        component: () => import(/* webpackChunkName: "Speciality" */ "../views/Speciality/Speciality.vue")
      },
      {
        path: "/lumiere-specialite/edit",
        name: "SpecialityEdit",
        meta: {
          title: 'Speciality Edit',
        },
        component: () => import(/* webpackChunkName: "SpecialityEdit" */ "../views/Speciality/Form.vue")
      },
      {
        path: "/lumiere-specialite/create",
        name: "SpecialityCreate",
        meta: {
          title: 'Ajouter une spécialité'
        },
        component: () => import(/* webpackChunkName: "SpecialityCreate" */ "../views/Speciality/Form.vue")
      },
      {
        path: "/conseil-orientation",
        name: "AdviceDetail",
        meta: {
          title: 'Conseil Orientation',
        },
        component: () => import(/* webpackChunkName: "AdviceDetail" */ "../views/AdviceDetail/AdviceDetail.vue")
      },
      {
        path: "/conseil-orientation/edit",
        name: "AdviceDetailEdit",
        meta: {
          title: 'Conseil Orientation Edit',
        },
        component: () => import(/* webpackChunkName: "AdviceDetailEdit" */ "../views/AdviceDetail/Form.vue")
      },
      {
        path: "/conseil-orientation/create",
        name: "AdviceDetailCreate",
        meta: {
          title: 'Ajouter un article'
        },
        component: () => import(/* webpackChunkName: "AdviceDetailCreate" */ "../views/AdviceDetail/Form.vue")
      },
      {
        path: "/notification",
        name: "Notification",
        meta: {
          title: 'Notification',
        },
        component: () => import(/* webpackChunkName: "Notification" */ "../views/Notification/Notification.vue")
      },
      {
        path: "/notification/edit",
        name: "NotificationEdit",
        meta: {
          title: 'Notification Edit',
        },
        component: () => import(/* webpackChunkName: "NotificationEdit" */ "../views/Notification/Form.vue")
      },
      {
        path: "/notification/create",
        name: "NotificationCreate",
        meta: {
          title: 'Création d\'une nouvelle notification',
        },
        component: () => import(/* webpackChunkName: "NotificationCreate" */ "../views/Notification/Form.vue")
      },
    ]
  }
];



const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const loggedIn = !!localStorage.getItem('user');
  const onlyWhenLoggedOut = to.matched.some(
      record => record.meta.onlyWhenLoggedOut,
  );
  if(to.name === 'Default') {
    return next({
      name: 'News',
    });
  }
  if (loggedIn && onlyWhenLoggedOut) {
    return next({
      name: 'News',
    });
  }

  if (!loggedIn && !onlyWhenLoggedOut) {
    return next({
      name: 'Login'
    });
  }
  document.title = `${process.env.VUE_APP_NAME} - ${to.meta.title}`;

  next();
});
export default router;
